// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"365":"562b3235","439":"cb61c86c","885":"64f31e73","975":"4b4d3c03"}[chunkId] + ".chunk.js";
};